<template>
  <div>
    <md-dialog-confirm
      :md-active.sync="active"
      md-title="Delete Super BOM?"
      md-content=""
      md-confirm-text="Yes"
      md-cancel-text="No"
      @md-confirm="onConfirm"/>

    <md-button class="md-icon-button md-dense md-accent" @click="active = true">
      <md-icon>remove_circle</md-icon>
    </md-button>
  </div>
</template>

<script>
  export default {
    name: 'DeleteSuperBom',
    data: () => ({
      active: false,
    }),
    props: ['supebomId'],
    methods: {
      onConfirm () {
        this.$store.dispatch('actionDeleteSuperBom', this.supebomId)
      },
    }
  }
</script>
